import React from 'react';
import { UserCircleIcon } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import packageJson from '../../../package.json';
export const Header: React.FC = () => {
  const {
    user,
    logout
  } = useAuth();
  return <header className="bg-white border-b border-gray-200 z-10">
      <div className="px-4 md:px-6 py-4 flex items-center justify-between">
        <div className="flex-1">
          <h1 className="text-2xl font-semibold text-gray-800">
            Resort Admin v. {packageJson.version}
          </h1>
        </div>
        <div className="flex items-center space-x-4">
          <div className="relative group">
            <div className="flex items-center space-x-2 cursor-pointer">
              <UserCircleIcon className="w-8 h-8 text-gray-500" />
              <div>
                <p className="text-sm font-medium text-gray-700">
                  {user?.name}
                </p>
                <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
              </div>
            </div>
            <div className="absolute right-0 top-full pt-2 w-full z-20 hidden group-hover:block">
              <div className="bg-white rounded-md shadow-lg py-1">
                <button onClick={logout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>;
};